export default __webpack_public_path__ + "static/media/dealedge1.c3ee28f9.png";